import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    placeItems: 'center',
    border: ({ img }) => !img && 'solid 1px white',
    backgroundColor: ({ isYours }) =>
      isYours ? theme.palette.primary.main : '#CCCCCC',
    borderRadius: 8,
    gridGap: '4px',
    padding: '4px',
    position: 'absolute',
    zIndex: 2,
    right: '5px',
    top: ({ img }) => img && '5px',
    cursor: 'pointer'
  },
  menuItem: {
    borderRadius: 8,
    '&:hover': {
      backgroundColor: ({ isYours }) => (isYours ? '#863797' : '#666666')
    }
  },
  btnMenu: {
    padding: 0
  }
}))

export default useStyles
